import { Heading, Stack, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import FareRulesDrawerButton from '../../common/FareRulesDrawerButton';
import type { RebookEligibilityType } from './models';
import OrderChangeabilityContent from './OrderChangeabilityContent';

const dividerStyles = css`
  border-bottom: 1px solid ${vars.colors.divider};
`;

interface RebookingProps {
  rebookEligibilityType: RebookEligibilityType;
}
const Rebooking = ({ rebookEligibilityType }: RebookingProps) => {
  const { t } = useTranslation();

  return (
    <Stack aria-labelledby="rebooking-button" id="tab-panel-rebooking-button" role="tabpanel">
      <Stack spacing={24}>
        <Heading as="h3" level={2}>
          {t('ManageTrip.Reschedule.Title')}
        </Heading>
        <OrderChangeabilityContent
          rebookEligibilityType={rebookEligibilityType}
          shouldShowChangeTripButton
          shouldShowContactMethods
        />
      </Stack>
      <div className={dividerStyles} />
      <Heading as="h3" level={2}>
        {t('ManageTrip.CancellationRules.Title')}
      </Heading>
      <FareRulesDrawerButton
        snowplow={{
          category: 'Manage Trip',
          label: 'RESCHEDULE',
        }}
      />
    </Stack>
  );
};

export default Rebooking;
